import React from 'react';

function PartnersTutors() {
   return (
      <section className="w-full bg-light-3 py-12 md:py-16 lg:py-24 px-6 text-center">
         <h3 className="text-title font-bold text-dark-1 mb-6">🤝 Opportunités</h3>
         <div className="flex flex-col md:flex-row justify-center gap-6">
            <a href="/community" className="px-6 py-3 border-2 text-button border-blue-1 text-blue-1 hover:bg-blue-1 hover:text-white
              rounded-full transition-colors duration-300 font-medium">Devenir partenaire</a>
            <a href="/become-an-instructor" className="px-6 py-3 border-2 text-button border-red-4 text-red-4 hover:bg-red-4 hover:text-white
              rounded-full transition-colors duration-300 font-medium">Rejoindre nos tuteurs</a>
         </div>
      </section>
   )
};

export default PartnersTutors;